import {
  MarkupAmountType,
  TaxAmountType,
  PriceInput,
} from 'lane-shared/domains/billingPayments/types';
import {
  AdminFeeAmountType,
  PriceComponents,
} from 'application-types';

interface PriceInputWithAdminFeeTax extends PriceInput {
  adminFeeTax?: { type: TaxAmountType; value: string };
}

export function priceInputToComponents(
  priceInput: PriceInputWithAdminFeeTax
): PriceComponents {
  const { rate, markup, tax, netPrice, adminFee, adminFeeTax } = priceInput;

  const result: PriceComponents = {
    amount: Number(rate),
    markup: {
      value: Number(markup?.value || 0),
      markupAmountType:
        markup?.type || MarkupAmountType.MarkupAmountTypePercentage,
    },
    tax: {
      value: Number(tax?.value || 0),
      taxAmountType: tax?.type || TaxAmountType.TaxAmountTypePercentage,
    },
    netPrice: Number(netPrice),
  };

  if (adminFee?.value) {
    result.adminFee = {
      value: Number(adminFee.value),
      adminFeeAmountType:
        adminFee.type || AdminFeeAmountType.AdminFeeAmountTypePercentage,
    };
  }

  if (adminFeeTax?.value) {
    result.adminFeeTax = {
      rate: Number(adminFeeTax.value),
      taxAmountType: adminFeeTax.type || TaxAmountType.TaxAmountTypePercentage,
    };
  }

  return result;
}
